// Code generated by protoc-gen-ts_proto_ipc_plugin. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto_internal_plugin  v0.1.20
//   protoc               v6.30.2
// source: services/transportation/reports/bunker.proto

/* eslint-disable */
import { Injectable } from "@angular/core";
import { GrpcWebErrrHandlingImpl } from "src/app/shared/services/grpc-client";
import { EmptyRequest } from "../../../common/messages/messages";
import {
  BunkeringDeliveryNote,
  GetBunkeringDeliveryNoteRequest,
  GetBunkersRequest,
  GetBunkersResponse,
  GetOneBunkeringDeliveryNoteResponse,
  GetUpdatedBunkersRequest,
  UpdateBunkeringDeliveryNoteRequest,
} from "./bunker";

import { BunkerServiceClientImpl } from "./bunker";

@Injectable({ providedIn: "root" })
export class BunkerServiceSpa {
  constructor(private _rpc: GrpcWebErrrHandlingImpl) {}
  async addBunkerDeliveryNote(request: BunkeringDeliveryNote): Promise<GetOneBunkeringDeliveryNoteResponse> {
    const client = new BunkerServiceClientImpl(this._rpc);
    return await client.addBunkerDeliveryNote(request);
  }
  async getOneBunkerDeliveryNote(
    request: GetBunkeringDeliveryNoteRequest,
  ): Promise<GetOneBunkeringDeliveryNoteResponse> {
    const client = new BunkerServiceClientImpl(this._rpc);
    return await client.getOneBunkerDeliveryNote(request);
  }
  async updateBunkerDeliveryNote(
    request: UpdateBunkeringDeliveryNoteRequest,
  ): Promise<GetOneBunkeringDeliveryNoteResponse> {
    const client = new BunkerServiceClientImpl(this._rpc);
    return await client.updateBunkerDeliveryNote(request);
  }
  async getBunkers(request: GetBunkersRequest): Promise<GetBunkersResponse> {
    const client = new BunkerServiceClientImpl(this._rpc);
    return await client.getBunkers(request);
  }
  async getUpdatedBunkers(request: GetUpdatedBunkersRequest): Promise<GetBunkersResponse> {
    const client = new BunkerServiceClientImpl(this._rpc);
    return await client.getUpdatedBunkers(request);
  }
  async getAllBunkers(request: EmptyRequest): Promise<GetBunkersResponse> {
    const client = new BunkerServiceClientImpl(this._rpc);
    return await client.getAllBunkers(request);
  }
}
